const getters = {
	tag: (state) => state.tags.tag,
	website: (state) => state.common.website,
	userInfo: (state) => state.user.userInfo,
	userInfoMain: (state) => state.user.userInfoMain,
	theme: (state) => state.common.theme,
	themeName: (state) => state.common.themeName,
	isShade: (state) => state.common.isShade,
	isCollapse: (state) => state.common.isCollapse,
	keyCollapse: (state, getters) => (getters.screen > 1 ? getters.isCollapse : false),
	screen: (state) => state.common.screen,
	isLock: (state) => state.common.isLock,
	isFullScreen: (state) => state.common.isFullScreen || {},
	lockPasswd: (state) => state.common.lockPasswd,
	tagList: (state) => state.tags.tagList,
	tagWel: (state) => state.tags.tagWel,
	access_token: (state) => state.user.access_token,
	access_token_helper: (state) => state.user.access_token_helper,
	refresh_token: (state) => state.user.refresh_token,
	// Added by Li Yong on 2021/09/01
	aid: (state) => state.user.aid,
	// End
	expires_in: (state) => state.user.expires_in,
	roles: (state) => state.user.roles,
	isShowSettleHint: (state) => state.user.isShowSettleHint,
	insureTypes: (state) => state.user.insureTypes,
	permissions: (state) => state.user.permissions,
	menu: (state) => state.user.menu,
	menuAll: (state) => state.user.menuAll,
	logsList: (state) => state.logs.logsList,
	logsLen: (state) => state.logs.logsList.length || 0,
	logsFlag: (state, getters) => getters.logsLen === 0,
	//渠道控制
	difChannelType: (state) => state.user.difChannelType || {},
}
export default getters
